/**
 * MedCom CareCommunication: Communication.topic (Emne) is required only for
 * category "other" (Andet). Other categories may be sent without it
 * (MedCom test 3.3.2.3 sends "Vedr. henvisning" without Emne).
 */
export function topicRequired(category: string | null | undefined): boolean {
  return category === 'other';
}

/** Emne as sent: trimmed, and omitted (undefined) when empty. */
export function outgoingTopic(topic: string | null | undefined): string | undefined {
  const trimmed = topic?.trim() ?? '';
  return trimmed ? trimmed : undefined;
}
